import { ICopyable } from '../controls/common/icopyable';

export class SearchOptions implements ICopyable<SearchOptions> {
    public wholeWordOnlyEnabled: boolean = false;
    public sensitiveCaseEnabled: boolean = false;
    public specialCaractersIgnored: boolean = false;
    public minorDifferencesAccepted: boolean = false;
    public pluralizeEnabled: boolean = false;

    public createCopy(): SearchOptions {
        const instance = new SearchOptions();
        instance.wholeWordOnlyEnabled = this.wholeWordOnlyEnabled;
        instance.sensitiveCaseEnabled = this.sensitiveCaseEnabled;
        instance.specialCaractersIgnored = this.specialCaractersIgnored;
        instance.minorDifferencesAccepted = this.minorDifferencesAccepted;
        instance.pluralizeEnabled = this.pluralizeEnabled;
        return instance;
    }

    public copyFrom(other: any) {
        this.wholeWordOnlyEnabled = other.wholeWordOnlyEnabled;
        this.sensitiveCaseEnabled = other.sensitiveCaseEnabled;
        this.specialCaractersIgnored = other.specialCaractersIgnored;
        this.minorDifferencesAccepted = other.minorDifferencesAccepted;
        this.pluralizeEnabled = other.pluralizeEnabled;
    }
}
